import { useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

import { Helmet } from "react-helmet-async";
import { Formik } from "formik";
import {
    Button,
    Paper,
    TextField as MuiTextField,
    Typography,
} from "@material-ui/core";

import { useHistory } from "react-router-dom";

import { spacing } from "@material-ui/system";
import { useDispatch } from "react-redux";
import { Alert as MuiAlert } from "@material-ui/lab";
import * as Yup from "yup"
import { createNewPassword } from "../../redux/actions/authActions";


const Alert = styled(MuiAlert)(spacing);
const TextField = styled(MuiTextField)<{ my?: number }>(spacing);
const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)}px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)}px;
  }
`;

const ChangePassword = (p: RouteComponentProps<{
    key: string
}>) => {
    const key = p.location.search.replace(/\?key=/g, "");

    const dispatch = useDispatch();
    const [succes, setSucces] = useState(false);
    const history = useHistory();
    const { t } = useTranslation();
    console.log(p);
    return <Wrapper>
        <Helmet title={t("changePassword_newPassword_browserTab")} />

        {succes ? <>
            <Typography component="h1" variant="body1" align="center" gutterBottom>
                {`${t("changePassword_success")}!`}
        </Typography>
            <Typography component="h2" variant="body1" align="center" gutterBottom>
                {t("changePassword_successMessage")}
        </Typography>
            <Button
                onClick={() => {
                    history.push("/auth/sign-in");
                }}
                fullWidth
                variant="contained"
                color="primary"
            >
                {t("changePassword_returnToLogin")}
                </Button>
        </> : <>
                <Typography component="h1" variant="body1" align="center" gutterBottom>
                    {t("changePassword_resetPassword")}
        </Typography>
                <Formik
                    initialValues={{
                        password: "",
                        confirm_password: "",
                        submit: false,
                    }}
                    validateOnMount
                    validationSchema={Yup.object().shape({
                        password: Yup.string()
                            .min(6)
                            .max(128)
                            .required(t("changePassword_newPasswordRequired_errorMessage")),
                        confirm_password: Yup.string()
                            .min(6)
                            .max(128)
                            .oneOf([Yup.ref('password'), null], t("changePassword_newPasswordMismatch_errorMessage"))
                            .required(t("generalWords_Required"))
                    })}
                    onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                        try {
                            await dispatch(
                                createNewPassword({
                                    key,
                                    password: values.password
                                })
                            );
                            //   dispatch(
                            //     resetPassword({
                            //       email: values.email,
                            //     })
                            //   );
                            console.log(values);
                            setSucces(true);

                            // history.push("/auth/sign-in");
                        } catch (error) {
                            const message = error.message || t("signinForm_generalError");

                            setStatus({ success: false });
                            setErrors({ submit: message });
                            setSubmitting(false);
                        }
                    }}
                >
                    {({
                        errors,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        isValid,
                        touched,
                        values,
                    }) => (
                        <form noValidate onSubmit={handleSubmit}>
                            {errors.submit && (
                                <Alert mt={2} mb={1} severity="warning">
                                    {errors.submit}
                                </Alert>
                            )}
                            <TextField
                                type="password"
                                name="password"
                                label={t("changePassword_newPassword_label")}
                                value={values.password}
                                error={Boolean(touched.password && errors.password)}
                                fullWidth
                                helperText={touched.password && errors.password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                my={3}
                            />
                            <TextField
                                type="password"
                                name="confirm_password"
                                label={t("changePassword_confirmNewPassword_label")}
                                value={values.confirm_password}
                                error={Boolean(touched.confirm_password && errors.confirm_password)}
                                fullWidth
                                helperText={touched.confirm_password && errors.confirm_password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                my={3}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting || !isValid}
                            >
                                {t("changePassword_resetPassword")}
                    </Button>
                        </form>
                    )}
                </Formik>
            </>}
    </Wrapper>
}

export default ChangePassword;